import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import getTranslation from '../../../strings/i18n';
import statusMessages from '../../../const/status-messages';
import { statusColors } from '../../../styles/theme';
import { StyledTag } from './subcomponents';
var Status = function (_a) {
    var status = _a.status;
    var tryT = getTranslation().tryT;
    if (!status)
        return null;
    var statusColor = statusColors[status];
    return (_jsx(StyledTag, { content: tryT("common.".concat(status.toLowerCase(), "Status")), icon: _jsx(FontAwesomeIcon, { icon: statusMessages.get(status), color: statusColor.icon, size: "xs" }), backgroundColor: statusColor.background, textColor: statusColor.text }));
};
export default Status;
//# sourceMappingURL=index.js.map